<template>
  <div class="tc-container">
    <div class="tc-chart">
      <div class="myChart" ref="myChart" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'three-days',
    data() {
      return {}
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          backgroundColor: 'rgba(0, 0, 0, 0)',
          textStyle: {
            color: '#b3babe',
          },
          legend: {
            type: 'plain',
            top: 0,
            right: '2%',
            textStyle: {
              fontSize: 14,
            },
            itemGap: 20,
            itemWidth: 25,
            itemHeight: 15,
            data: [
              {
                name: '今日',
                color: '#F78020',
                textStyle: {
                  color: '#E6E6E6',
                },
              },
              {
                name: '昨日',
                color: '#02FFA3',
                textStyle: {
                  color: '#E6E6E6',
                },
              },
              {
                name: '前日',
                color: '#05BDD3',
                textStyle: {
                  color: '#E6E6E6',
                },
              },
            ],
          },
          tooltip: {
            trigger: 'axis',
            padding: [10, 10],
            extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)',
          },
          grid: {
            top: '15%',
            left: '10%',
            right: '5%',
            bottom: '15%',
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: '#FFFFFF', //x轴颜色
              },
            },
            axisLabel: {
              fontSize: 14,
              padding: [10, 0, 0, 0],
              color: '#FFFFFF',
            },
            axisTick: {
              show: false,
            },
            data: [
              '01时',
              '02时',
              '03时',
              '04时',
              '05时',
              '06时',
              '07时',
              '08时',
            ],
          },
          yAxis: {
            nameTextStyle: {
              fontSize: 14,
              color: '#FFFFFF',
            },
            nameGap: 30,
            axisLine: true,
            axisLabel: {
              fontSize: 14,
              color: '#FFFFFF',
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#123144',
                width: 3,
              },
            },
          },
          series: [
            {
              name: '今日',
              data: [150, 200, 400, 90, 200, 400, 90, 290],
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  color: 'rgba(247, 128, 32, 1)',
                  lineStyle: {
                    color: 'rgba(247, 128, 32, 1)',
                    width: 2,
                  },
                  areaStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      colorStops: [
                        {
                          offset: 0,
                          color: 'rgba(0, 0, 0, 0)', // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: 'rgba(247, 128, 32, 1)', // 100% 处的颜色
                        },
                      ],
                    },
                  },
                },
              },
            },
            {
              name: '昨日',
              data: [400, 354, 180, 450, 354, 180, 450, 650],
              type: 'line',
              showAllSymbol: true,
              symbolSize: 0,
              smooth: true,
              symbol: 'circle',
              itemStyle: {
                normal: {
                  color: 'rgba(6, 210, 137, 1)',
                  lineStyle: {
                    color: 'rgba(6, 210, 137, 1)',
                    width: 2,
                  },
                  areaStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      colorStops: [
                        {
                          offset: 0,
                          color: 'rgba(0, 0, 0, 0)', // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: 'rgba(6, 210, 137, 1)', // 100% 处的颜色
                        },
                      ],
                    },
                  },
                },
              },
            },
            {
              name: '前日',
              data: [500, 254, 280, 350, 554, 280, 150, 450],
              type: 'line',
              showAllSymbol: true,
              symbolSize: 0,
              smooth: true,
              symbol: 'circle',
              itemStyle: {
                normal: {
                  color: 'rgba(5, 189, 211, 1)',
                  lineStyle: {
                    color: 'rgba(5, 189, 211, 1)',
                    width: 2,
                  },
                  areaStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      colorStops: [
                        {
                          offset: 0,
                          color: 'rgba(0, 0, 0, 0)', // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: 'rgba(5, 189, 211, 1)', // 100% 处的颜色
                        },
                      ],
                    },
                  },
                },
              },
            },
          ],
        })
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tc-container {
    width: 100%;

    .tc-chart {
      width: 100%;
      height: 11.358vw;
      margin: 0 auto;

      .myChart {
        width: 100%;
        height: 11.358vw;
      }
    }
  }
</style>
